import './tripFactorDetails.css';

const TripFactorDetails = () => {
    return(
        <ul className={'trip-factors sf-medium grid hr-space-between col-4'}>
            <li>
                <div className="number">03</div>
                <div className="name">FCW</div>
            </li>
            <li className={'red-box'}>
                <div className="number">02</div>
                <div className="name">PCW</div>
            </li>
            <li>
                <div className="number">03</div>
                <div className="name">LDW</div>
            </li>
            <li>
                <div className="number">00</div>
                <div className="name">HA</div>
            </li>
            <li className={'org-box'}>
                <div className="number">05</div>
                <div className="name">HB</div>
            </li>
            <li>
                <div className="number">02</div>
                <div className="name">DIS</div>
            </li>
            <li className={'red-box'}>
                <div className="number">08</div>
                <div className="name">HMW</div>
            </li>
            <li>
                <div className="number">03</div>
                <div className="name">DRW</div>
            </li>
        </ul>
    )
}

export default TripFactorDetails;
